import React, { useMemo } from 'react';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import Slider from 'react-slick';
import { useSelector } from 'react-redux';
import Sport from '../../shared/SportIcons/Sport';
import { ESPORTS, LANGUAGES } from '../../../constants/defaultValues';
import { generateEventsUrl } from '../../../utils/helpers';

import styles from './SportsNav.module.scss';

const NavItems = ({ onMouseDown, onSportClick, sliderSettings }) => {
    const locale = useSelector(state => state.settings.locale);

    const { sportsList } = useSelector(state => state.sportTypes);

    const { isLive, isESports, sportRefId } = useSelector(state => state.sportEvents);

    const filteredSportsList = useMemo(() => {
        const favoriteId = '0:bt:sport:1';

        return sportsList.filter(
            sport => !!sport && sport.referenceId !== favoriteId
        );
    }, [sportsList]);

    const renderSportsList = sports =>
        sports.map(sport => {
            const isFavorites = sport.referenceId === '0:bt:sport:1';

            const referenceId = isFavorites ? 'favorites' : sport.referenceId;

            const eventCount = sport.eventCount;

            const isActive = sportRefId === referenceId;

            return (
                <div key={sport.id}>
                    <NavLink
                        className={classnames(styles.navLink, {
                            [styles.active]: isActive,
                        })}
                        to={{
                            pathname: generateEventsUrl({
                                isLive,
                                isESports,
                                sportId: encodeURIComponent(referenceId),
                            }),

                            sportProps: {
                                sportName: sport.names[locale] || sport.names[LANGUAGES.eng],
                                eventCount,
                            },
                        }}
                        onMouseDown={onMouseDown}
                        onClick={onSportClick}
                    >
                        <Sport sportId={referenceId} isActive={isActive} className={styles.icon} />
                        <span className={styles.title}>{sport.names[locale] || sport.names[LANGUAGES.eng]}</span>
                        <span className={styles.count}>{`(${eventCount})`}</span>
                    </NavLink>
                </div>
            );
        });

    return isLive ? (
        <Slider {...sliderSettings}>{renderSportsList(filteredSportsList)}</Slider>
    ) : (
        renderSportsList(filteredSportsList)
    );
};

export default NavItems;
